import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export type UserRole = "admin" | "moderator" | "vendor" | "user";

/**
 * Fetches roles from public.user_roles for the given user and returns the
 * highest-priority role. Defaults to "user" while loading or if no rows.
 */
export function useUserRole(userId: string | null | undefined): UserRole {
  const [role, setRole] = useState<UserRole>("user");

  useEffect(() => {
    if (!userId) return;
    let cancelled = false;
    (async () => {
      const { data } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", userId);
      if (cancelled || !data || data.length === 0) return;
      const roles = data.map((r: any) => r.role);
      if (roles.includes("admin")) setRole("admin");
      else if (roles.includes("moderator")) setRole("moderator");
      else if (roles.includes("vendor")) setRole("vendor");
      else setRole(roles[0] as UserRole);
    })();
    return () => {
      cancelled = true;
    };
  }, [userId]);

  return role;
}